<script>
  import _ from 'lodash'
  import mixins from './mixins'
  export default {
    name: 'VCheckbox',
    mixins: [mixins],
    data() {
      return {}
    },

    render() {
      return (
        <ElFormItem
          prop={this.prop}
          rules={this.explainValidate()}
          label-width="0"
        >
          <ElCheckbox
            value={_.get(this.row, this.column.prop)}
            onChange={(value) => {
              _.set(this.row, this.column.prop, value)
              if (this.config.onChange) {
                //解析prop 获取到父表的行索引，以及目前所在的行索引
                this.config.onChange(
                  this.tableRoot.tableData,
                  this.row,
                  this.column,
                  this.prop.split('.'),
                  value
                )
              }
            }}
          />
        </ElFormItem>
      )
    },
  }
</script>
